import AppNavDropdown from "components/AppNav/AppNavDropdown";
import AppNavIcon from "components/AppNav/AppNavIcon";
import _ from "lodash";
import { useState } from "react";

interface Props {
  items: {
    label: string;
    path?: string;
    href?: string;
    onClick?: (e?: React.MouseEvent<HTMLDivElement>) => void;
  }[];
}

/**
 * User navigation for mobile
 */
const AppNavMobile = (props: Props) => {
  const [mobileNavIsOpen, setMobileNavIsOpen] = useState(false);

  const options = props.items.map((item) => {
    const hasOnClick = !!item.onClick;
    const hasHref = !!item.href;
    return {
      contents: (
        <>
          <span className="mr-3">
            <AppNavIcon type={item.label as any} />
          </span>
          {item.label}
        </>
      ),
      ...(hasOnClick
        ? { onClick: item.onClick }
        : hasHref
        ? { href: item.href }
        : { to: item.path }),
    };
  });

  return (
    <div
      className="sidebar-nav-item cursor-pointer mr-3"
      onClick={() => setMobileNavIsOpen(!mobileNavIsOpen)}
    >
      <span>
        <AppNavIcon type={"Navigation"} active={false} />
        <AppNavDropdown
          isOpen={mobileNavIsOpen}
          setIsOpen={setMobileNavIsOpen}
          options={options}
        />
      </span>
    </div>
  );
};
export default AppNavMobile;
